import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { B2CTypePayment, B2CTypeTable } from '@/types.ts'
import { B2CRegistryStatus, B2CState } from '@/@types/b2c.types.ts'
import { SetFilterValue } from '@/stores/shared.ts'

export interface B2CTableState {
  dateFrom?: string
  dateTo?: string
  b2cType?: B2CTypeTable
  b2cState?: B2CState | 'ALL'
  b2cRegistryState?: B2CRegistryStatus | 'ALL'
  b2cPaymentsType?: B2CTypePayment
  b2cRegistryNumber?: string
}

const initialState: B2CTableState = {
  dateFrom: undefined,
  dateTo: undefined,
  b2cType: undefined,
  b2cState: undefined,
  b2cRegistryState: undefined,
  b2cPaymentsType: undefined,
  b2cRegistryNumber: undefined,
}

const b2cSlice = createSlice({
  name: 'b2c',
  initialState,
  selectors: {
    resettableStateFilters: (state, filters: (keyof B2CTableState)[]) => filters.map((e) => state[e]),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<B2CTableState>>) => {
      return {
        ...state,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof B2CTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const { reducer: b2cReducer, selectors: b2cSelectors, actions: b2cActions } = b2cSlice
